import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Camera, X } from "lucide-react";

export default function QRScanner({ onResult, onClose }) {
  const scannerRef = useRef(null);
  const elementId = "qr-scanner-region";
  const [error, setError] = useState("");

  useEffect(() => {
    let scanner;
    let cancelled = false;

    const start = async () => {
      try {
        scanner = new Html5Qrcode(elementId, { verbose: false });
        scannerRef.current = scanner;
        await scanner.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 260, height: 260 } },
          (decodedText) => {
            if (cancelled) return;
            cancelled = true;
            try {
              scanner.stop().catch(() => {});
            } catch {}
            onResult(decodedText);
          },
          () => {}
        );
      } catch (e) {
        setError(
          "Camera access denied or unavailable. Please allow camera permission."
        );
      }
    };

    start();
    return () => {
      cancelled = true;
      if (scannerRef.current) {
        try {
          scannerRef.current.stop().catch(() => {});
        } catch {}
      }
    };
  }, [onResult]);

  return (
    <div
      className="fixed inset-0 z-[100] bg-slate-900/95 flex flex-col"
      data-testid="qr-scanner-modal"
    >
      <div className="h-16 bg-slate-900 border-b-2 border-amber-500 flex items-center justify-between px-4">
        <div className="flex items-center gap-2 text-white font-display uppercase tracking-wider">
          <Camera className="h-5 w-5 text-amber-400" />
          Scan MR Barcode
        </div>
        <button
          onClick={onClose}
          data-testid="qr-close-btn"
          className="h-12 w-12 grid place-items-center text-white border-2 border-slate-700 rounded-sm hover:bg-slate-800"
        >
          <X strokeWidth={3} className="h-5 w-5" />
        </button>
      </div>
      <div className="flex-1 grid place-items-center p-4">
        <div
          id={elementId}
          className="w-full max-w-md bg-black rounded-sm overflow-hidden border-2 border-amber-500"
        />
      </div>
      {error && (
        <div className="bg-rose-700 text-white px-4 py-3 text-sm font-bold" data-testid="qr-error">
          {error}
        </div>
      )}
      <div className="bg-slate-800 text-slate-300 text-xs px-4 py-3 text-center">
        Aim camera at MR barcode/QR. Auto-fills MR number.
      </div>
    </div>
  );
}
